/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Legajox_Employees_SuccessInputs */

const es_tools_legajox_employees_success = /** @type {(inputs: Tools_Legajox_Employees_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empleados de Legajox consultados`)
};

const en_tools_legajox_employees_success = /** @type {(inputs: Tools_Legajox_Employees_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legajox employees queried`)
};

/**
* | output |
* | --- |
* | "Legajox employees queried" |
*
* @param {Tools_Legajox_Employees_SuccessInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_legajox_employees_success = /** @type {((inputs?: Tools_Legajox_Employees_SuccessInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Legajox_Employees_SuccessInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_legajox_employees_success(inputs)
	return en_tools_legajox_employees_success(inputs)
});
export { tools_legajox_employees_success as "tools.legajox.employees_success" }